import { create } from 'zustand';

interface LayoutPositionsState {
    positions: Record<string, number>; // { [deviceUID]: index }
    setPosition: (deviceUID: string, index: number) => void;
    setPositions: (positions: Record<string, number>) => void;
    getPosition: (deviceUID: string) => number | undefined;
}

const useLayoutPositionsStore = create<LayoutPositionsState>((set, get) => ({
    positions: {},
    setPosition: (deviceUID, index) =>
        set((state) => ({ positions: { ...state.positions, [deviceUID]: index } })),
    setPositions: (positions) => set({ positions }),
    getPosition: (deviceUID) => get().positions[deviceUID],
}));

export default useLayoutPositionsStore;
